export default __webpack_public_path__ + "static/demo-image-01-cc9d2e3ed0e5328100ea7145bee28c4c.jpg";